import { lazy } from "react";

import { routers } from "@/configs";

const Favorites = lazy(() => import("@/pages/Main/Favorites"));
const Recent = lazy(() => import("@/pages/Main/Recent"));

export const MainRoutes = [
  {
    path: routers.Recent,
    element: <Recent />,
  },
  {
    path: routers.Favorites,
    element: <Favorites />,
  },
];
